// Each full batch of ten posts contains six Gal posts and four other posts.
// Select before rendering so expanding threads never changes their edition.
export function mixSocialEditions(galCards, otherCards, random = Math.random) {
  if (!galCards.length) return otherCards;
  if (!otherCards.length) return galCards;
  const total = Math.min(Math.max(galCards.length, otherCards.length),
    Math.floor(galCards.length / 0.6), Math.floor(otherCards.length / 0.4));
  const result = [];
  let galIndex = 0;
  let otherIndex = 0;
  while (result.length < total) {
    const size = Math.min(10, total - result.length);
    const galCount = Math.round(size * 0.6);
    const batch = [
      ...galCards.slice(galIndex, galIndex + galCount),
      ...otherCards.slice(otherIndex, otherIndex + size - galCount),
    ];
    galIndex += galCount;
    otherIndex += size - galCount;
    for (let i = batch.length - 1; i > 0; i--) {
      const j = Math.floor(random() * (i + 1));
      [batch[i], batch[j]] = [batch[j], batch[i]];
    }
    result.push(...batch);
  }
  return result;
}
